import { z } from 'zod';
import { ProcessSchema, ProcessCategorySchema } from '../../entities/process';
import { ObjectIdSchema } from '../../shared/object-id.schema';
const EditProcessRequestSchemaObj = z.object({
    owner: z.string(),
    accountable: ObjectIdSchema.or(z.literal('')),
    department: z.string(),
    name: z.string(),
    description: z.string(),
    apqcEquivalentId: z.string(),
    // TODO: Review AI Code for feature: Process Map
    category: ProcessCategorySchema.nullable()
});
/**
 * Edit Process Request Schema
 * PATCH /api/v2/process/:id
 * All fields are optional - only provided fields will be updated
 * Request sends IDs for owner and department
 */ export const EditProcessRequestSchema = EditProcessRequestSchemaObj.partial();
/**
 * Edit Process Response Schema
 * Returned on successful process update
 * Contains the updated process object with populated fields
 */ export const EditProcessResponseSchema = z.object({
    process: ProcessSchema
});
/**
 * Edit Process Error Schema
 * Returned when process update fails
 * Contains standard error information
 */ export const EditProcessErrorSchema = z.object({
    statusCode: z.number(),
    message: z.string(),
    error: z.string()
});

//# sourceMappingURL=edit-process.schema.js.map